import { text_mod_54 } from "../text/Text.js";

export const module54 = {
  title: "Уживання прикметників у власних висловленнях",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_54,
    },
  ],
};
